export interface BagTypeOption {
  value: string;
  label: string;
}

export const BAG_TYPE_OPTIONS: BagTypeOption[] = [
  { value: 'new_50kg', label: 'New 50 kg' },
  { value: 'used_50kg', label: 'Used 50 kg' },
  { value: 'jute', label: 'Jute' },
  { value: 'hdpe', label: 'HDPE' },
  { value: 'pp', label: 'PP' },
  { value: 'cotton', label: 'Cotton' },
  { value: 'other', label: 'Other' },
];

export const DEFAULT_BAG_TYPE = 'new_50kg';

const labelMap: Record<string, string> = Object.fromEntries(
  BAG_TYPE_OPTIONS.map((o) => [o.value, o.label]),
);

export function bagTypeLabel(value: string | null | undefined): string {
  if (!value) return '—';
  return labelMap[value] ?? value.charAt(0).toUpperCase() + value.slice(1);
}
